export enum LaboratoryTubeStatus {
  NoControlado = 1,
  Rechazado = 3,
  Aceptado = 2
}
